import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import Dashboard from "./dashboard/Dashboard";
import Sidebar from "./sidebar/Sidebar";
import ContextProvider from "./Context";
import ContactList from "./contactlist/ContactList";
import Blog from "./blog_list/Blog";
import Addblog from "./blog_list/Addblog";
import Login from "./login/Login";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "./comp/loader/Loader";

function App() {
  const [username, setUsername] = useState(localStorage.getItem("username"));

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setUsername(localStorage.getItem("username"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("username");
    setUsername(null);
  };
  return (
    <div className="App">
      <ToastContainer
        className="toast_container"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        z-ind
      />
      <ContextProvider>
        <BrowserRouter>
          {username && <Sidebar handleLogout={handleLogout} />}
        

          {loader && <Loader />}

          <Routes>
            {username ? (
              <>
                {" "}
                <Route path="/" element={<Dashboard setLoader={setLoader} />} />
                <Route
                  path="/contactlist"
                  element={<ContactList setLoader={setLoader} />}
                />
                <Route
                  path="/bloglist"
                  element={<Blog setLoader={setLoader} />}
                />
                <Route
                  path="/addBlog"
                  element={<Addblog setLoader={setLoader} />}
                />
              </>
            ) : (
              <Route path="*" element={<Login setUsername={setUsername} />} />
            )}
          </Routes>
        </BrowserRouter>
      </ContextProvider>
    </div>
  );
}

export default App;
